import * as React from "react";

import { Checkbox, SpacingToken } from "@livechat/design-system-react-components";

import Block from "components/layout/Block";
import { Column } from "constants/tickets/columns";
import { getIsMemberOfTicketTeam } from "helpers/tickets";
import { ITicket } from "interfaces/entities/ticket";
import { IAgent } from "store/entities/agents";
import { withVar } from "themes/helpers";

import { Td, Th, cellPaddingCss } from "./tickets-styles";

interface IProps {
  checked: boolean;
  isPrimary: boolean;
  ticketId?: string;
  ticket?: ITicket;
  currentAgent?: IAgent;
  shiftData?: { start: ITicket | null };
  onChange(e: React.ChangeEvent<HTMLInputElement>, shiftKey?: boolean): void;
}

export class TicketCheckbox extends React.PureComponent<IProps> {
  private shiftButtonClicked = false;

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  private saveShiftData = (event: React.MouseEvent<HTMLInputElement>) => {
    const { shiftData, ticket } = this.props;

    if (shiftData && (shiftData.start === null || !event.shiftKey)) {
      // @ts-expect-error TS(2322): Type 'ITicket | undefined' is not assignable to ty... Remove this comment to see the full error message
      shiftData.start = ticket;
    }

    this.shiftButtonClicked = event.shiftKey;

    return true;
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
  private handleOnChange = (e: any) => {
    const { onChange } = this.props;

    onChange(e, this.shiftButtonClicked);
  };

  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { checked, isPrimary, ticketId, currentAgent, ticket } = this.props;
    const isTeamMember = currentAgent && ticket ? getIsMemberOfTicketTeam(currentAgent, ticket) : false;

    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const attrs: any = {};
    let Component;

    if (isPrimary) {
      Component = Th;
    } else {
      Component = Td;
      attrs.css = cellPaddingCss;
    }

    return (
      <Component column={Column.Checkbox} {...attrs}>
        <Block marginTop={withVar(SpacingToken.Spacing1)} css={{ textAlign: "left" }}>
          <Checkbox
            disabled={(ticket && !!ticket.parentTicket) || (!isPrimary && !isTeamMember)}
            title={isTeamMember ? "" : "You do not have an access to modify this ticket"}
            checked={checked}
            onChange={this.handleOnChange}
            onClick={this.saveShiftData}
            data-ticket-id={ticketId}
          />
        </Block>
      </Component>
    );
  }
}
